import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "tgo_consent";
export const OPEN_EVENT = "tgo:cookie-settings";

const readConsent = () => { try { return localStorage.getItem(KEY); } catch { return null; } };

const clearAnalyticsStorage = () => {
  try { Object.keys(localStorage).filter((k) => k.startsWith("ph_")).forEach((k) => localStorage.removeItem(k)); } catch { /* storage unavailable */ }
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("ph_"))
    .forEach((n) => { document.cookie = `${n}=; Max-Age=0; path=/`; document.cookie = `${n}=; Max-Age=0; path=/; domain=.${window.location.hostname}`; });
};

export const applyConsent = (choice) => {
  try { localStorage.setItem(KEY, choice); } catch { /* storage unavailable */ }
  const ph = window.posthog;
  if (choice === "analytics") {
    ph?.set_config?.({ persistence: "localStorage+cookie", advanced_disable_flags: false, advanced_disable_decide: false });
    ph?.opt_in_capturing?.();
    ph?.reloadFeatureFlags?.();
    ph?.startSessionRecording?.();
  } else {
    ph?.stopSessionRecording?.();
    ph?.opt_out_capturing?.();
    ph?.set_config?.({ persistence: "memory", advanced_disable_flags: true, advanced_disable_decide: true });
    clearAnalyticsStorage();
  }
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => !readConsent());
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, show);
    return () => window.removeEventListener(OPEN_EVENT, show);
  }, []);
  if (!open) return null;
  const choose = (c) => { applyConsent(c); setOpen(false); };
  const current = readConsent();
  return (
    <div role="dialog" aria-label="Cookie choices" aria-live="polite"
      className="fixed inset-x-3 bottom-3 z-[90] mx-auto max-w-2xl rounded-2xl border border-border bg-card/95 p-5 shadow-2xl backdrop-blur-xl sm:inset-x-6 sm:bottom-6 sm:p-6"
      data-testid="cookie-banner">
      <div className="flex gap-4">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="font-semibold">Your privacy, your choice</p>
          <p className="mt-1 text-sm text-foreground/80">
            We use essential cookies to keep you signed in. With your permission we'd also use analytics, including session recordings, to improve the club. Nothing is tracked unless you accept.{" "}
            <Link to="/privacy" className="text-primary underline-offset-2 hover:underline" data-testid="cookie-banner-privacy-link">Privacy</Link>
          </p>
          {current && <p className="mt-2 text-xs text-muted-foreground" data-testid="cookie-current-choice">Current choice: {current === "analytics" ? "analytics accepted" : "essential only"}</p>}
          <div className="mt-4 flex flex-col gap-2 sm:flex-row">
            <button type="button" className="btn-primary h-11 px-5 text-sm" onClick={() => choose("analytics")} data-testid="cookie-accept-button">Accept analytics</button>
            <button type="button" className="btn-outline h-11 px-5 text-sm" onClick={() => choose("essential")} data-testid="cookie-essential-button">Essential only</button>
          </div>
        </div>
      </div>
    </div>
  );
};
